import { atom, selector, selectorFamily, useRecoilValue } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";
import {
  WX_ID_LIVECAMERA,
  WX_ID_RADAR,
  WX_ID_AMEYUKI,
  WX_ID_HIMAWARI,
  WX_ID_METARTAF,
  WX_ID_GASS_SCALE,
  WX_ID_SS_SCALE,
  WX_ID_POTEKA,
  WX_ID_LIGHTNING,
  WX_ID_AMEDAS,
  WX_ID_SYNOP,
  WX_ID_SST,
  WX_ID_LFM,
  WX_ID_MSM,
  WX_ID_GSM,
  WX_ID_TROPICALCYCLONE,
  WX_ID_VAA,
  WX_ID_ACOS,
  WX_ID_TIME_SCOPE_COMPOSITE_RADAR,
  WX_ID_GFS,
  WX_ID_WNI_OCEAN_CURRENT,
  WX_ID_SORACAMELIGHT
} from "./WeatherContentsState";
import {
  MAP_ID_FLIGHTPLAN_LIST,
  MAP_ID_COPILOT,
  MAP_ID_AIRWAY,
  MAP_ID_FIR,
  MAP_ID_FIX,
  MAP_ID_NAVAIDS,
  MAP_ID_CONTROL_ZONE,
  MAP_ID_INFORMATION_ZONE,
  MAP_ID_TRAINING_AIRSPACE,
  MAP_ID_POWER_LINES,
  MAP_ID_POWER_PYLONS
} from "./MapContentsState";
import {
  MESSAGE_WIDGET
} from "./MessageState";
import { RC_INFORMATION_PANEL } from "./RcInformationState";

export const CONTENTS_ID_FLIGHTPLAN         = 'fm01'; //飛行計画
export const CONTENTS_ID_COPILOT            = 'fm02'; //Copilot
export const CONTENTS_ID_MESSAGE            = 'fm03'; //メッセージ
export const CONTENTS_ID_LIVECAMERA         = 'lc01'; //ライブカメラ
export const CONTENTS_ID_SORACAME           = 'lc02'; //ソラカメ
export const CONTENTS_ID_RADAR_JP           = 'rd01'; //日本レーダー
export const CONTENTS_ID_RADAR_KR           = 'rd02'; //韓国レーダー
export const CONTENTS_ID_RADAR_TW           = 'rd03'; //台湾レーダー
export const CONTENTS_ID_AMEYUKI            = 'rd04'; //雨雪判定
export const CONTENTS_ID_NOWCAST            = 'rd05'; //降水ナウキャスト
export const CONTENTS_ID_XRAIN              = 'rd06'; //C-XRain
export const CONTENTS_ID_RADAR_JMA_PRCINT   = 'rd07'; //JAM高解像度
export const CONTENTS_ID_COMPOSITE_RADAR    = 'rd08'; //実況・予測レーダー
export const CONTENTS_ID_HIMA8              = 'st01'; //Himawari-8
export const CONTENTS_ID_HIMA8_CB           = 'st02'; //CB解析
export const CONTENTS_ID_HIMA8_VAA          = 'st03'; //VAA解析
export const CONTENTS_ID_METAR_TAF          = 'aw01'; //METAR/TAF
export const CONTENTS_ID_RC                 = 'aw02'; //RC Daily/Weekly
export const CONTENTS_ID_GASS_SCALE         = 'aw03'; //GASS Scale
export const CONTENTS_ID_SS_SCALE           = 'aw04'; //SS Scale
export const CONTENTS_ID_TEXT_LINK          = 'aw05'; //TEXT(外部システムリンク)
export const CONTENTS_ID_CHART_LINK         = 'aw06'; //CHART(Links Pro)
export const CONTENTS_ID_POINT_SUMMARY      = 'aw07'; //Point Summary(Links Pro)
export const CONTENTS_ID_POTEKA             = 'ob01'; //POTEKA
export const CONTENTS_ID_LIGHTNING          = 'ob02'; //雷
export const CONTENTS_ID_AMEDAS             = 'ob03'; //AMeDAS
export const CONTENTS_ID_SYNOP              = 'ob04'; //SYNOP
export const CONTENTS_ID_SST                = 'ob05'; //SST
export const CONTENTS_ID_LFM                = 'md01'; //LFM
export const CONTENTS_ID_MSM                = 'md02'; //MSM
export const CONTENTS_ID_GSM                = 'md03'; //GSM
export const CONTENTS_ID_GFS                = 'md04'; //GFS
export const CONTENTS_ID_WNI_OCEAN_CURRENT  = 'md05'; //WNI Ocean Current
export const CONTENTS_ID_TC_GLOBAL          = 'tp02'; //WNI Global TC
export const CONTENTS_ID_TC_JMA             = 'tp03'; //JMA
export const CONTENTS_ID_TC_JTWC            = 'tp04'; //JTWC
export const CONTENTS_ID_TC_FOCS_LINK       = 'tp05'; //FOCS(外部システムリンク)
export const CONTENTS_ID_VAA                = 'va01'; //VAA
export const CONTENTS_ID_ACOS               = 'va02'; //ACOS
export const CONTENTS_ID_CTRL_ZONE          = 'ac01'; //管制圏
export const CONTENTS_ID_INFO_ZONE          = 'ac02'; //情報圏
export const CONTENTS_ID_TRAINING_AREA      = 'ac03'; //訓練空域
export const CONTENTS_ID_AIRWAY             = 'ac04'; //AIRWAY
export const CONTENTS_ID_FIR                = 'ac05'; //FIR
export const CONTENTS_ID_FIX                = 'ac06'; //FIX
export const CONTENTS_ID_NAVAIDS            = 'ac07'; //Navaids
export const CONTENTS_ID_POWER_LINES        = 'bg02'; //送電線
export const CONTENTS_ID_POWER_PYLONS       = 'bg03'; //鉄塔
export const CONTENTS_ID_POWER_LINES_SNK    = 'bg04'; //送電線(新日本ヘリコプター)
export const CONTENTS_ID_POWER_PYLONS_SNK   = 'bg05'; //鉄塔(新日本ヘリコプター)

const disabledContentsState = atom({
  key: 'disabledContentsState',
  default: selector({
    key: 'disabledContentsStateSelector',
    get: () => {
      return getCustomerSettings('disabledContents') || {};
    }
  })
});

export const disabledContentsWithID = selectorFamily({
  key: 'disabledContentsWithID',

  get: (id) => ({get}) => {

    const ID_MAPPING = {
      [WX_ID_LIVECAMERA] : CONTENTS_ID_LIVECAMERA,
      [WX_ID_RADAR] : {
        Japan: CONTENTS_ID_RADAR_JP,
        Korea: CONTENTS_ID_RADAR_KR,
        Taiwan: CONTENTS_ID_RADAR_TW,
        NOWCAST: CONTENTS_ID_NOWCAST,
        XRAIN: CONTENTS_ID_XRAIN,
        PRCINT: CONTENTS_ID_RADAR_JMA_PRCINT
      },
      [WX_ID_AMEYUKI] : CONTENTS_ID_AMEYUKI,
      [WX_ID_TIME_SCOPE_COMPOSITE_RADAR]: CONTENTS_ID_COMPOSITE_RADAR,
      [WX_ID_HIMAWARI] : {
        IRHT: CONTENTS_ID_HIMA8,
        IRHT_COLOR: CONTENTS_ID_HIMA8,
        IRTP: CONTENTS_ID_HIMA8,
        IRTP_COLOR: CONTENTS_ID_HIMA8,
        WV: CONTENTS_ID_HIMA8,
        VIS: CONTENTS_ID_HIMA8,
        IRDIFF: CONTENTS_ID_HIMA8,
        CB: CONTENTS_ID_HIMA8_CB,
        VAA: CONTENTS_ID_HIMA8_VAA
      },
      [WX_ID_METARTAF] : CONTENTS_ID_METAR_TAF,
      [WX_ID_GASS_SCALE] : CONTENTS_ID_GASS_SCALE,
      [WX_ID_SS_SCALE] : CONTENTS_ID_SS_SCALE,
      [WX_ID_POTEKA] : CONTENTS_ID_POTEKA,
      [WX_ID_LIGHTNING] : CONTENTS_ID_LIGHTNING,
      [WX_ID_AMEDAS] : CONTENTS_ID_AMEDAS,
      [WX_ID_SYNOP] : CONTENTS_ID_SYNOP,
      [WX_ID_SST] : CONTENTS_ID_SST,
      [WX_ID_LFM] : CONTENTS_ID_LFM,
      [WX_ID_MSM] : CONTENTS_ID_MSM,
      [WX_ID_GSM] : CONTENTS_ID_GSM,
      [WX_ID_GFS] : CONTENTS_ID_GFS,
      [WX_ID_WNI_OCEAN_CURRENT] : CONTENTS_ID_WNI_OCEAN_CURRENT,
      [WX_ID_TROPICALCYCLONE] : {
        WNIGlobalTC: CONTENTS_ID_TC_GLOBAL,
        JMA: CONTENTS_ID_TC_JMA,
        JTWC: CONTENTS_ID_TC_JTWC
      },
      [WX_ID_VAA] : CONTENTS_ID_VAA,
      [WX_ID_ACOS] : CONTENTS_ID_ACOS,
      [MAP_ID_FLIGHTPLAN_LIST] : CONTENTS_ID_FLIGHTPLAN,
      [MAP_ID_COPILOT] : CONTENTS_ID_COPILOT,
      [MAP_ID_AIRWAY] : CONTENTS_ID_AIRWAY,
      [MAP_ID_FIR] : CONTENTS_ID_FIR,
      [MAP_ID_FIX] : CONTENTS_ID_FIX,
      [MAP_ID_NAVAIDS] : CONTENTS_ID_NAVAIDS,
      [MESSAGE_WIDGET] : CONTENTS_ID_MESSAGE,
      [MAP_ID_CONTROL_ZONE] : CONTENTS_ID_CTRL_ZONE,
      [MAP_ID_INFORMATION_ZONE] : CONTENTS_ID_INFO_ZONE,
      [MAP_ID_TRAINING_AIRSPACE] : CONTENTS_ID_TRAINING_AREA,
      [MAP_ID_POWER_LINES] : {
        [CONTENTS_ID_POWER_LINES]: CONTENTS_ID_POWER_LINES,
        [CONTENTS_ID_POWER_LINES_SNK]: CONTENTS_ID_POWER_LINES_SNK
      },
      [MAP_ID_POWER_PYLONS] : {
        [CONTENTS_ID_POWER_PYLONS]: CONTENTS_ID_POWER_PYLONS,
        [CONTENTS_ID_POWER_PYLONS_SNK]: CONTENTS_ID_POWER_PYLONS_SNK
      },
      [RC_INFORMATION_PANEL] : CONTENTS_ID_RC,
      [WX_ID_SORACAMELIGHT] : CONTENTS_ID_SORACAME,
    };

    const disabled = get(disabledContentsState);
    if (ID_MAPPING[id] === undefined) {
      return false;
    } else if (typeof ID_MAPPING[id] === 'string') {
      return disabled[ID_MAPPING[id]] || false;
    } else {
      const ret = {};
      const keys = Object.keys(ID_MAPPING[id]);
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i];
        const contentsId = ID_MAPPING[id][k];
        ret[k] = disabled[contentsId];
      }
      return ret;
    }
  },
});

export const useDisabledContents = () => {
  const disabled = useRecoilValue(disabledContentsState);
  return {
    disabled
  };
};
